import { BLOCK } from "./agentContract";

// What a chat produced, for the chat switcher: a kind (drives the row icon) and
// one plain line. Worked out from the thread's blocks when it is saved, so the
// list never has to load whole conversations.
const strip = s => String(s || "")
  .replace(/\*\*|__|`|#+\s/g, "")
  .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
  .replace(/\s+[—–]\s+/g, ", ")
  .replace(/\s+/g, " ")
  .trim();

const firstSentence = s => {
  const t = strip(s);
  const m = t.match(/^(.{12,140}?[.!?])(\s|$)/);
  return (m ? m[1] : t).slice(0, 140);
};

export const chatOutcome = messages => {
  const blocks = [];
  let lastText = "";
  (messages || []).forEach(m => {
    if (m.role !== "assistant") return;
    (m.blocks || []).forEach(b => {
      blocks.push(b);
      if (b.type === BLOCK.TEXT && b.markdown) lastText = b.markdown;
    });
  });
  const has = type => blocks.some(b => b.type === type);
  const last = type => [...blocks].reverse().find(b => b.type === type);

  let kind = "chat";
  let summary = "";
  const draft = last(BLOCK.AGENT_DRAFT);
  const agents = last(BLOCK.AGENT_LIST);
  if (draft) {
    kind = "agent";
    const name = (draft.agent && draft.agent.name) || "Agent";
    summary = draft.phase === "created" ? `${name}, saved as a draft` : `${name}, drafted`;
  } else if (agents) {
    kind = "agent";
    const n = (agents.agents || []).length;
    summary = `${n} agent${n === 1 ? "" : "s"}`;
  } else if (has(BLOCK.DRAFT_REVIEW) || has(BLOCK.SEQUENCE_LIST)) {
    kind = "sequence";
  } else if (has(BLOCK.TABLE_REF) || /\bsaved?\b.*\blist\b/i.test(lastText)) {
    kind = "list";
  } else if (has(BLOCK.RECORD_DETAIL) || has(BLOCK.CITATIONS) || has(BLOCK.TIMELINE)) {
    kind = "research";
  }
  if (!summary && lastText) summary = firstSentence(lastText);
  return { kind, summary };
};
